import React from "react";
import { View, StyleSheet, Image, TouchableHighlight, Button, TouchableNativeFeedback } from "react-native";

import Text from "../Text";
import colors from "../../config/colors";
//import { TouchableOpacity } from "react-native-gesture-handler";

function ListItemSearch({
    title,
    subTitle,
    image,
    IconComponent,
    onPress,
    onPressGenerateSeed
}) {
    return (
        <TouchableHighlight underlayColor={colors.light} onPress={onPress}>
            <View style={styles.container}>
                {IconComponent}
                {image && <Image style={styles.image} source={{ uri: image }} />}
                <View style={styles.detailsContainer}>
                    <Text onPress={onPressGenerateSeed} style={styles.title} >
                        {title}
                    </Text>
                    {subTitle && (
                        <Text style={styles.subTitle} >
                            {subTitle}
                        </Text>
                    )}
                </View>
            </View>
        </TouchableHighlight>
    );
}

const styles = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        padding: 15,
        backgroundColor: colors.white,
    },
    detailsContainer: {
        marginLeft: 10,
        justifyContent: "center",
    },
    image: {
        width: 70,
        height: 70,
        borderRadius: 5,
    },
    imageButton: {
        backgroundColor: 'yellow',
        width: 70,
        height: 70,
        borderRadius: 35,
    },
    subTitle: {
        color: colors.medium,
        textAlign: 'justify',
        marginRight:"20%"
    },
    title: {
        fontWeight: "500",
        //textAlign: 'center',
        marginRight:"15%",
        marginBottom: 15
    },
});

export default ListItemSearch;
